import { render, staticRenderFns } from "./DetailCalendarioComponent.vue?vue&type=template&id=9786d79a&scoped=true"
import script from "./DetailCalendarioComponent.vue?vue&type=script&lang=js"
export * from "./DetailCalendarioComponent.vue?vue&type=script&lang=js"
import style0 from "./DetailCalendarioComponent.vue?vue&type=style&index=0&id=9786d79a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9786d79a",
  null
  
)

export default component.exports